import { GET_DASHBORD } from "@/api/dashboard";

import querystring from "query-string";

const state = {
    list: {}
};

const mutations = {
    SET_LIST: (state, payload) => {
        state.list = payload;
    },
};


const actions = {
    GET_LIST: async ({ commit }, params) => {
        params = querystring.stringify(params);
        const resp = await GET_DASHBORD(params);
        const data = resp.data.data;
        commit("SET_LIST", data);
    },
};

const getters = {
    list: (state) => state.list,
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
};